import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-toggle',
  styleUrls: ['toggle.component.scss'],
  template: `
    <div class="toggle-button-container">
      <div
        (click)="!disabled && toggleChange.next(!toggled)"
        class="toggel-button"
        [ngClass]="{
          'toggel-button-active': toggled,
          disabled: disabled
        }"
      >
        <div class="button"></div>
      </div>
      <span for=""><ng-content select="*"></ng-content></span>
    </div>
  `,
})
export class ToggleComponent implements OnInit {
  @Input() toggled: boolean = false;
  @Input() disabled: boolean = false;
  @Output() toggleChange: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
